import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import ParticipationDropRatingsContainer from "./ratings/ParticipationDropRatingsContainer";
interface ParticipationDropRatingsProps {
  readonly drop: ApiDrop;
  readonly rank?: number | null | undefined;
  readonly winningThreshold?: number | null | undefined;
  readonly winningThresholdMinDurationMs?: number | null | undefined;
  readonly isVotingClosed?: boolean | undefined;
}
export const ParticipationDropRatings: React.FC<ParticipationDropRatingsProps> = t0 => {
  const $ = _c(6);
  const {
    drop,
    rank: t1,
    winningThreshold,
    winningThresholdMinDurationMs,
    isVotingClosed: t2
  } = t0;
  const rank = t1 === undefined ? null : t1;
  const isVotingClosed = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== drop || $[1] !== isVotingClosed || $[2] !== rank || $[3] !== winningThreshold || $[4] !== winningThresholdMinDurationMs) {
    t3 = <ParticipationDropRatingsContainer drop={drop} rank={rank} winningThreshold={winningThreshold} winningThresholdMinDurationMs={winningThresholdMinDurationMs} isVotingClosed={isVotingClosed} />;
    $[0] = drop;
    $[1] = isVotingClosed;
    $[2] = rank;
    $[3] = winningThreshold;
    $[4] = winningThresholdMinDurationMs;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};